export function getPathValue(path, object) {
    return path.split('.').reduce((value, key) => value?.[key], object);
}
